import { render, staticRenderFns } from "./QuestionDropDownBox.vue?vue&type=template&id=021b55bd&scoped=true&"
import script from "./QuestionDropDownBox.vue?vue&type=script&lang=js&"
export * from "./QuestionDropDownBox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDropDownBox.vue?vue&type=style&index=0&id=021b55bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b55bd",
  null
  
)

export default component.exports